import { createApp } from 'vue';
import Menu from './menu.vue';

const menuElement = document.getElementById('menu');

if (menuElement) {
    const navigationData = JSON.parse(menuElement.getAttribute('data-navigation') || '[]');
    const projectEntries = JSON.parse(menuElement.getAttribute('data-project-entries') || '[]');

    createApp(Menu, {
        navigation: navigationData,
        projectEntries: projectEntries,
        logoImageUrl: menuElement.getAttribute('data-logo-image-url'),
        buzzImageUrl: menuElement.getAttribute('data-buzz-image-url'),
    }).mount('#menu');
}
